import React from "react";
import "./PlacementSection.css";
import {
  FaUserTie,
  FaClipboardList,
  FaLaptopCode,
  FaBriefcase,
} from "react-icons/fa";

export default function PlacementSection() {
  const features = [
    { icon: <FaUserTie />, title: "Exclusive Linkedin Masterclasses" },
    { icon: <FaClipboardList />, title: "Resume Writing Workshop" },
    { icon: <FaLaptopCode />, title: "Mock Interviews" },
    { icon: <FaBriefcase />, title: "Job Placements" },
  ];

  return (
    <div className="placement-section_job">
      <div className="placement-content">
        <h1>Placement Assistance for Your Dream Job</h1>
        <p>
          Chandigarh University assists its students in unlocking their fullest
          professional potential.
        </p>

        <div className="features-grid">
          {features.map((item, index) => (
            <div className="feature-card" key={index}>
              <div className="feature-icon">{item.icon}</div>
              <p>{item.title}</p>
            </div>
          ))}
        </div>
      </div>

      {/* Right-side image */}
      <div className="placement-image"></div>
    </div>
  );
}
